import {
  SUPPLIER_FILTER_REQUEST_BASE,
  SUPPLIER_STATUS_FILTER_SHOW_ALL,
  SUPPLIER_TYPE_FILTER_ALL,
  SUPPLIER_TYPE_FILTER_CODE,
} from 'src/constants/manageSuppliers';
import { ManageSupplierTypeFilterItem } from 'src/types/manage-suppliers/ManageSupplier';
import { SupplierFilterRequest } from 'src/types/manage-suppliers/SupplierFilter';

// Selected types -> backend codes. All selected (or none) -> [AllSuppliers].
const toSupplierFilters = (types: ManageSupplierTypeFilterItem[]): number[] => {
  const selectable = types.filter((type) => type.display);
  const allSelected = selectable.every((type) => type.show);
  if (allSelected) return [SUPPLIER_TYPE_FILTER_ALL];
  return selectable
    .filter((type) => type.show)
    .map((type) => SUPPLIER_TYPE_FILTER_CODE[type.field]);
};

export interface BuildSupplierFilterRequestParams {
  statusFilter: number;
  supplierTypeFilter: ManageSupplierTypeFilterItem[];
}

// Builds the Supplier/Filter POST body. Grid paging/sort/column filters are applied
// client-side via Kendo process(). Search is sent separately as a ?filterBy= query param.
export const buildSupplierFilterRequest = ({
  statusFilter,
  supplierTypeFilter,
}: BuildSupplierFilterRequestParams): SupplierFilterRequest => ({
  ...SUPPLIER_FILTER_REQUEST_BASE,
  supplierFilters: toSupplierFilters(supplierTypeFilter),
  statusFilter,
  queryOptions: {
    clientSide: true,
    skip: 0,
    take: 0,
    skipCalculatingTotalRecordsCount: false,
    sort: [],
    filters: [],
  },
});

// Same request as buildSupplierFilterRequest, scoped to companyId and flagged for export.
// exportCompanyIds is only sent for a chunked export.
export const buildSupplierExportFilterRequest = (
  params: BuildSupplierFilterRequestParams & { companyId: number; exportCompanyIds?: number[] }
): SupplierFilterRequest => ({
  ...buildSupplierFilterRequest(params),
  companyId: params.companyId,
  isExport: true,
  ...(params.exportCompanyIds ? { exportCompanyIds: params.exportCompanyIds } : {}),
});

export const buildOnlineSupplierFilterRequest = (
  supplierClientId: number
): SupplierFilterRequest => ({
  ...SUPPLIER_FILTER_REQUEST_BASE,
  offlineSupplierId: null,
  supplierClientId,
  supplierFilters: [SUPPLIER_TYPE_FILTER_ALL],
  statusFilter: SUPPLIER_STATUS_FILTER_SHOW_ALL,
  queryOptions: {
    clientSide: true,
    skip: 0,
    take: 0,
    skipCalculatingTotalRecordsCount: false,
    sort: [],
    filters: [],
  },
});

export const buildOfflineSupplierFilterRequest = (
  offlineSupplierId: number
): SupplierFilterRequest => ({
  ...SUPPLIER_FILTER_REQUEST_BASE,
  offlineSupplierId,
  supplierClientId: null,
  supplierFilters: [SUPPLIER_TYPE_FILTER_CODE.offline],
  statusFilter: SUPPLIER_STATUS_FILTER_SHOW_ALL,
  queryOptions: {
    clientSide: true,
    skip: 0,
    take: 0,
    skipCalculatingTotalRecordsCount: false,
    sort: [],
    filters: [],
  },
});

